import { useState } from 'react';
import { FaPlus, FaTrash, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import FieldRenderer from '../FieldRenderer';
import styles from '../PropertyPanel.module.css';

function CollectionField({ label, items = [], onChange, fieldDef, blockPath, dispatch, config, editMode }) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleAdd = () => {
    const newItem = { ...fieldDef.defaultItem };
    newItem.id = `item_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
    onChange([...items, newItem]);
  };

  const handleRemove = (index) => {
    const updated = items.filter((_, i) => i !== index);
    onChange(updated);
  };

  const handleItemChange = (index, key, value) => {
    const updated = items.map((item, i) => {
      if (i !== index) return item;
      return { ...item, [key]: value };
    });
    onChange(updated);
  };

  return (
    <div className={styles.field}>
      <div className={styles.collectionHeader}>
        <span className={styles.fieldLabel}>{label} ({items.length})</span>
        <button className={styles.collectionAdd} onClick={handleAdd}>
          <FaPlus />
        </button>
      </div>
      <div className={styles.collectionList}>
        {items.map((item, index) => (
          <div key={item.id || index} className={styles.collectionItem}>
            <div
              className={styles.collectionItemHeader}
              onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
            >
              {expandedIndex === index ? <FaChevronDown /> : <FaChevronRight />}
              <span>Item {index + 1}</span>
              <button
                className={styles.collectionRemove}
                onClick={(e) => { e.stopPropagation(); handleRemove(index); }}
              >
                <FaTrash />
              </button>
            </div>
            {expandedIndex === index && fieldDef.collectionSchema && (
              <div className={styles.collectionItemBody}>
                {fieldDef.collectionSchema.map((subField) => (
                  <FieldRenderer
                    key={subField.key}
                    fieldDef={{ ...subField, target: 'props' }}
                    value={item[subField.key]}
                    onDirectChange={(val) => handleItemChange(index, subField.key, val)}
                    blockPath={blockPath}
                    dispatch={dispatch}
                    config={config}
                    editMode={editMode}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CollectionField;
